import { PageContext } from "../hooks/usePageContext";

/**
 * Wraps a search term with product context if we're on a PDP page.
 * Returns the original search term if not on a PDP or if the search term
 * already contains a product tag.
 */
export const wrapSearchWithProductContext = (
  searchTerm: string,
  pageContext?: PageContext
): string => {
  // If not on a PDP or no stacklineSku, return as-is
  if (pageContext?.pageType !== "pdp" || !pageContext?.stacklineSku) {
    return searchTerm;
  }

  // If the search term already contains a product tag, return as-is
  if (searchTerm.includes("<product")) {
    return searchTerm;
  }

  // Wrap the search term with product context
  return `<product featured="true" stacklineSku="${pageContext.stacklineSku}" question="${searchTerm}" />`;
};

